import React, { ReactNode } from 'react';

interface WidgetHeaderPanelProps {
  children?: ReactNode;
}

const WidgetHeaderPanel: React.FC<WidgetHeaderPanelProps> = ({ children }) => {
  return <div className="widget-header-panel">{children}</div>;
};

export default WidgetHeaderPanel;
